// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.missions-map-popup .maplibregl-popup-content {
    background: #000;
    color: #fff;
    border-radius: 8px;
    padding: 8px;
}

.missions-map-popup.maplibregl-popup-anchor-top .maplibregl-popup-tip {
    border-bottom-color: #000;
}

.missions-map-popup.maplibregl-popup-anchor-top-left .maplibregl-popup-tip {
    border-bottom-color: #000;
}

.missions-map-popup.maplibregl-popup-anchor-top-right .maplibregl-popup-tip {
    border-bottom-color: #000;
}

.missions-map-popup.maplibregl-popup-anchor-bottom .maplibregl-popup-tip {
    border-top-color: #000
}

.missions-map-popup.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip {
    border-top-color: #000
}

.missions-map-popup.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip {
    border-top-color: #000
}

.missions-map-popup.maplibregl-popup-anchor-left .maplibregl-popup-tip {
    border-right-color: #000;
}

.missions-map-popup.maplibregl-popup-anchor-right .maplibregl-popup-tip {
    border-left-color: #000;
}
/* Map credit look shared by all Alpha apps (same as the Leaflet credit in missionMap/mapCredit.ts) */
.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib {
    margin: 0;
    padding: 1px 6px;
    background: rgba(255, 255, 255, 0.65);
    color: #323232;
    font: 12px/16px "Avenir Next W00", "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-align: right;
}

.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib a {
    color: inherit;
    text-decoration: none;
}

.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib a:hover,
.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib a:focus {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/main_container/missions/map/custom-maplibre-gl.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;AACA,qGAAqG;AACrG;IACI,SAAS;IACT,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,iFAAiF;IACjF,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,0BAA0B;AAC9B","sourcesContent":[".missions-map-popup .maplibregl-popup-content {\n    background: #000;\n    color: #fff;\n    border-radius: 8px;\n    padding: 8px;\n}\n\n.missions-map-popup.maplibregl-popup-anchor-top .maplibregl-popup-tip {\n    border-bottom-color: #000;\n}\n\n.missions-map-popup.maplibregl-popup-anchor-top-left .maplibregl-popup-tip {\n    border-bottom-color: #000;\n}\n\n.missions-map-popup.maplibregl-popup-anchor-top-right .maplibregl-popup-tip {\n    border-bottom-color: #000;\n}\n\n.missions-map-popup.maplibregl-popup-anchor-bottom .maplibregl-popup-tip {\n    border-top-color: #000\n}\n\n.missions-map-popup.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip {\n    border-top-color: #000\n}\n\n.missions-map-popup.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip {\n    border-top-color: #000\n}\n\n.missions-map-popup.maplibregl-popup-anchor-left .maplibregl-popup-tip {\n    border-right-color: #000;\n}\n\n.missions-map-popup.maplibregl-popup-anchor-right .maplibregl-popup-tip {\n    border-left-color: #000;\n}\n/* Map credit look shared by all Alpha apps (same as the Leaflet credit in missionMap/mapCredit.ts) */\n.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib {\n    margin: 0;\n    padding: 1px 6px;\n    background: rgba(255, 255, 255, 0.65);\n    color: #323232;\n    font: 12px/16px \"Avenir Next W00\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    text-align: right;\n}\n\n.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib a {\n    color: inherit;\n    text-decoration: none;\n}\n\n.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib a:hover,\n.maplibregl-ctrl-bottom-right .maplibregl-ctrl.maplibregl-ctrl-attrib a:focus {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
